function initializeProduct(root=document){
  const picker=root.querySelector('#VariantSelect');
  if(!picker||picker.dataset.ready)return;
  picker.dataset.ready='true';
  picker.addEventListener('change',()=>{
    const selected=picker.selectedOptions[0];
    if(!selected)return;
    const price=document.getElementById('VariantPrice');
    const button=document.getElementById('AddToCart');
    if(price)price.textContent=selected.dataset.price;
    if(button){button.disabled=selected.dataset.available!=='true';button.textContent=button.disabled?'Sold out':'Add to bag';}
    const url=new URL(window.location.href);url.searchParams.set('variant',selected.value);window.history.replaceState({},'',url);
  });
}
initializeProduct();
document.addEventListener('shopify:section:load',event=>initializeProduct(event.target));
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.nav-group[open]').forEach(group=>group.removeAttribute('open'));});
document.addEventListener('click',event=>{document.querySelectorAll('.nav-group[open]').forEach(group=>{if(!group.contains(event.target))group.removeAttribute('open');});});
